
const messages = {
    en: {
       role: {
            permissions: {
                BASE_SHOW: "Base Module",
            }
       }
    },
    es: {
        role: {
            permissions: {
                BASE_SHOW: "Modulo Base",
            }
       }
    },
    pt: {
       role: {
            permissions: {
                BASE_SHOW: "Modulo Base",
            }
       }
    }
}

export default messages
